// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"457d5bcd","952":"defe8a5d"}[chunkId] + ".chunk.js";
};